<template>
  <component :is="component" />
</template>

<script>
export default {
  name: 'EIcon',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  computed: {
    component() {
      // IMPORTANT! do not remove this line
      // accessing the `id` reactive property of the component VM here
      // ensures that the computed is updated when the `id` changes.
      // Calling `this.id` inside the import statement does not count,
      // because when Vue tries to figure out the "dependencies" of this computed,
      // it will not execute the returned function
      const { id } = this;
      return () => import(
        /* webpackMode: "lazy" */
        `./svg/${id}.svg`
      );
    },
  },
};
</script>
